<template>
	<div class="card-carousel-wrapper">
		<div class="card-carousel--nav__left" @click="moveCarousel(-1)" :disabled="atHeadOfList"></div>
		<div class="card-carousel">
			<div class="card-carousel--overflow-container">
				<div class="card-carousel-cards" :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
					<div class="card-carousel--card" v-for="(item,index) in items" :key="index">
                        <img v-bind:src="item.img">
                        <a v-bind:href="item.link" target="_blank"></a>                        						
					</div>
				</div>
			</div>
		</div>
		<div class="card-carousel--nav__right" @click="moveCarousel(1)" :disabled="atEndOfList"></div>
	</div>
</template>

<script>
export default {
  name: 'update',
  data() {
    return {
      currentOffset: 0,
      windowSize: 5,
      paginationFactor: 220,
      items: [
        {name: '01v', link: "https://www.m3guo.com/activity/202201/fes-13488ce/index.html",img : require('../images/ad/1.jpg')},
        {name: '09v', link: "https://www.m3guo.com/activity/202112/version-ma2q9vs/pc.html",img : require('../images/ad/4.jpg')},
        {name: 'yayun', link: "https://mp.weixin.qq.com/s/Yxnjr7SjKrp5MYCIHMi3lQ",img : require('../images/ad/3.jpg')},  
        {name: '10v', link: "https://www.m3guo.com/activity/202108/v/",img : require('../images/ad/2.jpg')},      
      ]
    }
  },
  computed: {
    atEndOfList() {
      return this.currentOffset <= (this.paginationFactor * -1) * (this.items.length - this.windowSize);
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
  methods: {
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-carousel-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0 40px;
  color: #666a73;
}

.card-carousel {
  display: flex;
  justify-content: center;
}
.card-carousel--overflow-container {
  overflow: hidden;
}
.card-carousel--nav__left, .card-carousel--nav__right {
  position: absolute;
  top: 64px;
  display: inline-block;
  width: 44px;
  height: 46px;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  margin: 0 10px;
  transition: transform 150ms linear;
  background-image: url(../images/btn-prev.png);
}
.card-carousel--nav__left[disabled], .card-carousel--nav__right[disabled] {
  display: none;
  opacity: 0.2;
}
.card-carousel--nav__left {
  /* transform: rotate(-135deg); */
  left: -140px;
}
.card-carousel--nav__left:active {
  transform: scale(0.9);
}
.card-carousel--nav__right {
  right: -140px;
  transform: rotate(180deg);
}
.card-carousel--nav__right:active {
  transform: rotate(180deg) scale(0.9);
}

.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
}
.card-carousel-cards .card-carousel--card {
    position: relative;
  width: 260px;
  height: 164px;
  background-image: url(../images/bg-update-item.png);
  margin: 0 10px;
  cursor: pointer;
}
.card-carousel-cards .card-carousel--card:first-child {
  margin-left: 0;
}
.card-carousel-cards .card-carousel--card:last-child {
  margin-right: 0;
}
.card-carousel-cards .card-carousel--card img {
    display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 243px;
  height: 139px;
  transform: translate(-50%,-50%);
  transition: opacity 150ms linear;
  user-select: none;
  cursor: pointer;
}
.card-carousel-cards .card-carousel--card img:hover {
  opacity: 0.5;
}

.card-carousel-cards .card-carousel--card a{
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
} 

</style>



// WEBPACK FOOTER //
// src/components/update.vue